import { createContext, useCallback, useContext, useRef, useState } from 'react';

const ToastContext = createContext(null);

/* Shared toast/snackbar system — ported from the sample UI's #toasts.
   Any portal can call useToast() once wrapped in a ToastProvider. */
export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const seq = useRef(0);

  const dismiss = useCallback((id) => {
    setToasts((cur) => cur.filter((t) => t.id !== id));
  }, []);

  const toast = useCallback(
    (message, kind, code) => {
      const id = ++seq.current;
      setToasts((cur) => [...cur, { id, message, kind, code }]);
      setTimeout(() => dismiss(id), 4600);
    },
    [dismiss]
  );

  return (
    <ToastContext.Provider value={{ toast }}>
      {children}
      <div className="toasts" aria-live="polite">
        {toasts.map((t) => (
          <div className={'toast' + (t.kind ? ' ' + t.kind : '')} key={t.id}>
            {t.message}
            {t.code && <span className="c">{t.code}</span>}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within a ToastProvider');
  return ctx.toast;
}
